var exports = {
  "container": "xf61da738--3c25b0--container",
  "container--size-m": "xf61da738--3c25b0--container--size-m",
  "container--size-s": "xf61da738--3c25b0--container--size-s",
  "container--active": "xf61da738--3c25b0--container--active",
};

module.exports = exports;
